import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    details: null,
    subscriptions: [],
    school: null,
    settings: null,
    payment: null,
    quizzes: [],
}

export const studentAccountSlice = createSlice({
    name: 'studentAccount',
    initialState,
    reducers: {
        updateStudentAccount: (state, action) => {
            state.details = action.payload?.details ? action.payload?.details : state.details;
            state.subscriptions = action.payload?.subscriptions ? action.payload?.subscriptions : state.subscriptions;
            state.school = action.payload?.school ? action.payload?.school : state.school;
            state.settings = action.payload?.settings ? action.payload?.settings : state.settings;
            state.payment = action.payload?.payment ? action.payload?.payment : state.payment;
            state.quizzes = action.payload?.quizzes ? action.payload?.quizzes : state.quizzes;
        },
        updateStudentDetails: (state, action) => {
            state.details = action.payload;
        },
        updateStudentSubscriptions: (state, action) => {
            state.subscriptions = action.payload;
        },
        updateStudentSchool: (state, action) => {
            state.school = action.payload;
        },
        updateStudentSettings: (state, action) => {
            state.settings = action.payload;
        },
        updateStudentPayment: (state, action) => {
            console.log('STUDENT PAYMENT to redux');
            state.payment = action.payload;
        },
        updateStudentQuizzes: (state, action) => {
            state.quizzes = action.payload;
        },
        updateStudentQuiz: (state, action) => {
            const updatedQuizzes = state.quizzes.map(quiz => quiz.id === action.payload.id ? action.payload : quiz);
            state.quizzes = updatedQuizzes;
        },
        clearStudentAccount: (state) => {
            state.details = null;
            state.subscriptions = null;
            state.school = null;
            state.settings = null;
            state.payment = null;
            state.quizzes = [];
        },
    }
});

export const {
    updateStudentAccount,
    updateStudentDetails,
    updateStudentSubscriptions,
    updateStudentSchool,
    updateStudentSettings,
    updateStudentPayment,
    clearStudentAccount,
    updateStudentQuizzes,
    updateStudentQuiz
} = studentAccountSlice.actions;

export default studentAccountSlice.reducer;
